/* eslint-disable react-hooks/rules-of-hooks */
// @ts-nocheck
import { useNotificationSummary } from '@dev-togetherprice/api.notification';
import { useUserInfo } from '@dev-togetherprice/api.user';
import BellIcon from '@dev-togetherprice/icons.bell';
import GiftIcon from '@dev-togetherprice/icons.gift';
import BackButton from '@dev-togetherprice/components.back-button';
import IconButton from '@dev-togetherprice/components.icon-button';
import LazyAvatar from '@dev-togetherprice/components.lazy-avatar';
import SearchField, { defaultSearchProps, } from '@dev-togetherprice/components.search-field';
import VerticalCentered from '@dev-togetherprice/components.vertical-centered';
import { AppBar, Badge, Grid, Hidden, makeStyles, Toolbar, Typography, } from '@material-ui/core';
import React from 'react';
import { mergeClasses } from '@material-ui/styles';
import clsx from 'clsx';
import { Skeleton } from '@material-ui/lab';
const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    appbar: {},
    gutter: {
        paddingTop: theme.spacing(3),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
    },
    avatar: {
        height: '50px',
        width: '50px',
        border: `1px solid ${theme.palette.common.white}`,
        objectFit: 'cover',
    },
    titleWrapper: {
        flex: 1,
        justifyContent: 'center',
        paddingLeft: theme.spacing(3),
    },
    title: {
        color: theme.palette.primary.main,
    },
    subtitle: {
        fontWeight: 300,
    },
    titleLine: {
        '&:after': {
            display: 'block',
            content: '" "',
            width: 35,
            height: 2,
            backgroundColor: theme.palette.primary.main,
        },
    },
    notificationsBadge: {
        right: theme.spacing(3),
    },
    iconWithNotReadNotifications: {
        border: `1px solid ${theme.palette.secondary.main}`,
    },
    searchWrapper: {
        display: 'flex',
        alignItems: 'center',
        marginTop: theme.spacing(4),
    },
    icon: {
        height: '40px',
        width: '40px',
        marginLeft: theme.spacing(6),
        border: `1px solid ${theme.palette.common.white}`,
    },
}));
export const MobileHeaderSkeleton = ({ classes: newClasses, isPublic, showUserInfo, onBack, title, subtitle, showNotification, showSearch, showReferral, }) => {
    const baseClasses = useStyles();
    const classes = mergeClasses({
        newClasses,
        baseClasses,
        Component: MobileHeaderSkeleton,
    });
    return (React.createElement(Hidden, { mdUp: true },
        React.createElement(AppBar, { className: classes.appbar, position: 'static', color: 'transparent', elevation: 0 },
            React.createElement(Toolbar, { className: classes.root },
                React.createElement(Grid, { container: true, className: clsx('', {
                        [classes.gutter]: showUserInfo,
                    }) },
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(Grid, { container: true, direction: 'row', justifyContent: 'space-between' },
                            showUserInfo && (React.createElement(Grid, { item: true },
                                React.createElement(VerticalCentered, null,
                                    React.createElement(Skeleton, { className: classes.avatar, variant: 'circle' })))),
                            React.createElement(Grid, { xs: true, container: true, direction: 'row' },
                                onBack && React.createElement(BackButton, { onBack: onBack }),
                                React.createElement(Grid, { className: classes.titleWrapper, container: true, direction: 'column', justifyContent: 'center' },
                                    title && React.createElement(Skeleton, { variant: 'text', height: 32 }),
                                    subtitle && React.createElement(Skeleton, { variant: 'text', height: 24 }))),
                            showNotification && !isPublic && (React.createElement(Grid, { item: true },
                                React.createElement(VerticalCentered, null,
                                    React.createElement(Skeleton, { className: classes.icon, variant: 'circle' })))))),
                    (showSearch || showReferral) && (React.createElement(Grid, { item: true, xs: 12, className: classes.searchWrapper },
                        React.createElement(Grid, { container: true, direction: 'row', justifyContent: 'space-between' },
                            React.createElement(Grid, { item: true, xs: true },
                                React.createElement(Skeleton, { height: '100%' })),
                            showReferral && (React.createElement(Grid, { item: true },
                                React.createElement(VerticalCentered, null,
                                    React.createElement(Skeleton, { className: classes.icon, variant: 'circle' }))))))))))));
};
const MobileHeader = ({ classes: newClasses = {}, title, subtitle, titleLine, searchProps, showSearch, showUserInfo, onBack, showNotification, showReferral, isPublic, navigateToUrl, }) => {
    const userInfo = showUserInfo && useUserInfo();
    const notifications = showNotification && useNotificationSummary();
    const baseClasses = useStyles({ showSidebar: false });
    const classes = mergeClasses({
        baseClasses,
        newClasses,
        Component: MobileHeader,
    });
    return (React.createElement(Hidden, { mdUp: true },
        React.createElement(AppBar, { className: classes.appbar, position: 'static', color: 'transparent', elevation: 0 },
            React.createElement(Toolbar, { className: classes.root },
                React.createElement(Grid, { className: clsx({
                        [classes.gutter]: showUserInfo,
                    }), container: true },
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(Grid, { container: true, direction: 'row', justifyContent: 'space-between' },
                            showUserInfo && userInfo && (React.createElement(Grid, { item: true },
                                React.createElement(VerticalCentered, null,
                                    React.createElement(LazyAvatar, { classes: { avatar: classes.avatar }, src: userInfo.image, alt: `${userInfo.name} ${userInfo.surname}`, onClick: () => navigateToUrl('/account/profile'), lazyOptions: { visibleByDefault: true } })))),
                            React.createElement(Grid, { item: true, container: true, xs: true, direction: 'row' },
                                onBack && React.createElement(BackButton, { onBack: onBack }),
                                React.createElement(Grid, { className: classes.titleWrapper, container: true, direction: 'column', justifyContent: 'center' },
                                    title && (React.createElement(Typography, { variant: 'h1', color: 'primary', className: clsx(classes.title, {
                                            [classes.titleLine]: titleLine,
                                        }) }, title)),
                                    subtitle && (React.createElement(Typography, { variant: 'caption', color: 'textSecondary', className: classes.subtitle }, subtitle)))),
                            showNotification && !isPublic && (React.createElement(Grid, { item: true },
                                React.createElement(VerticalCentered, null,
                                    React.createElement(Badge, { invisible: !(notifications === null || notifications === void 0 ? void 0 : notifications.notRead), badgeContent: notifications === null || notifications === void 0 ? void 0 : notifications.notRead, color: 'secondary', overlap: 'circular', anchorOrigin: {
                                            vertical: 'bottom',
                                            horizontal: 'right',
                                        }, classes: {
                                            badge: classes.notificationsBadge,
                                        } },
                                        React.createElement(IconButton, { variant: 'outlined', color: 'primary', "aria-label": 'notifications', size: 'medium', className: clsx(classes.icon, {
                                                [classes.iconWithNotReadNotifications]: notifications === null || notifications === void 0 ? void 0 : notifications.notRead,
                                            }), onClick: () => navigateToUrl('/feed/requests') },
                                            React.createElement(BellIcon, null)))))))),
                    (showSearch || showReferral) && (React.createElement(Grid, { item: true, xs: 12, className: classes.searchWrapper },
                        React.createElement(Grid, { container: true, direction: 'row', justifyContent: 'space-between', spacing: 2 },
                            showSearch && (React.createElement(Grid, { item: true, xs: true },
                                React.createElement(SearchField, Object.assign({}, defaultSearchProps, searchProps)))),
                            showReferral && (React.createElement(Grid, { item: true },
                                React.createElement(VerticalCentered, null,
                                    React.createElement(IconButton, { variant: 'outlined', color: 'primary', "aria-label": 'referral', size: 'medium', className: classes.icon, onClick: () => navigateToUrl('/referral') },
                                        React.createElement(GiftIcon, null)))))))))))));
};
export default MobileHeader;
